import { logout } from "../api.js";
import { navigate, useRoute } from "../router.js";
import type { Session } from "../app.js";

const NAV = [
  { path: "/home", label: "Home" },
  { path: "/dashboard", label: "Files" },
  { path: "/databases", label: "Databases" },
  { path: "/assistant", label: "Assistant" },
  { path: "/stats", label: "Stats" },
  { path: "/docs", label: "Docs" },
  { path: "/settings", label: "Settings" },
] as const;

/** Only rendered for admins; the route and the API both check as well. */
const ADMIN_NAV = { path: "/admin", label: "Accounts" } as const;

export function Masthead({ session, onSignOut }: { session: Session; onSignOut: () => void }) {
  const path = useRoute();

  return (
    <header className="masthead">
      <a className="wordmark" href="/" onClick={link("/")}>
        saucer.sh
      </a>

      <nav className="masthead__nav">
        {session ? (
          <>
            {(session.user.isAdmin ? [...NAV, ADMIN_NAV] : NAV).map((item) => (
              <a
                key={item.path}
                className={`masthead__link${path === item.path ? " masthead__link--active" : ""}`}
                href={item.path}
                onClick={link(item.path)}
              >
                {item.label}
              </a>
            ))}
            <button
              className="button button--quiet"
              type="button"
              onClick={async () => {
                await logout();
                onSignOut();
                navigate("/");
              }}
            >
              Sign out
            </button>
            {session.user.avatarUrl ? (
              <img className="avatar" src={session.user.avatarUrl} alt={session.user.username} />
            ) : null}
          </>
        ) : (
          <>
            <a
              className={`masthead__link${path === "/managed" ? " masthead__link--active" : ""}`}
              href="/managed"
              onClick={link("/managed")}
            >
              Databases
            </a>
            <a
              className={`masthead__link${path === "/docs" ? " masthead__link--active" : ""}`}
              href="/docs"
              onClick={link("/docs")}
            >
              Docs
            </a>
            <a className="button" href="/login" onClick={link("/login")}>
              Sign in
            </a>
          </>
        )}
      </nav>
    </header>
  );
}

const link = (path: string) => (event: React.MouseEvent) => {
  event.preventDefault();
  navigate(path);
};
